"use strict";

module.exports = function (value) {
  var matchers = value.match(/([\d_]*)x([\d_]*)/);
  var l = matchers[1].replace('_', '.');
  var w = matchers[2].replace('_', '.');
  return "".concat(l, "\" x ").concat(w, "\"");
};